<template>
  <v-app id="inspire">

    <v-content>
      <vue-page-transition name="fade">
        <router-view />
      </vue-page-transition>
    </v-content>

  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      ShowHeaderText: "Learn Chinese  "
    };
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
